import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui, use_slice_user } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_number } from '@/state/ui/_base/LOCAL__ui_set_number';
import { set_interval } from '@/utils/utils_client';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { logw } from '@shared/utils/utils_logs';
import { timestamp_ms } from '@shared/utils/utils_time';
import { useRef, useState } from 'react';
import { UI_PRIMITIVE__tooltip } from '../../../components/ui/UI_PRIMITIVE__tooltip';

export function HARDWARE_STATS__fps() {
  const dispatch = use_dispatch();

  const { is_authorized, user_settings } = use_slice_user(['is_authorized', 'user_settings']);
  const { global__is_app_on_focus, global__fps } = use_slice_ui(['global__is_app_on_focus', 'global__fps']);

  const [fps, set_fps] = useState(global__fps);
  const ref_frame_count = useRef(0);
  const ref_running = useRef(true);
  const ref_request_id = useRef(CONSTANTS__shared.NUMBER_EMPTY_VALUE);

  const ref_ignore_until = useRef(timestamp_ms());

  const GRACE_PERIOD_MS = 10_000;

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (!global__is_app_on_focus) return void set_fps(0);
    if (!is_authorized) return void set_fps(0);

    ref_running.current = true;
    ref_request_id.current = requestAnimationFrame(measure);

    ref_ignore_until.current = timestamp_ms() + GRACE_PERIOD_MS;

    const interval_id = set_interval(() => {
      const current_fps = ref_frame_count.current;
      set_fps(current_fps);

      dispatch(LOCAL__ui_set_number({ key: 'global__fps', value: current_fps }));

      const date_now = timestamp_ms();
      const should_log = date_now > ref_ignore_until.current;

      if (should_log && current_fps < 20) logw(`low fps detected\t${current_fps}`);

      ref_frame_count.current = 0;
    }, CONSTANTS_TIME__client.INTERVAL_FPS);

    return () => {
      ref_running.current = false;

      clearInterval(interval_id);
      cancelAnimationFrame(ref_request_id.current);
    };
  }, [global__is_app_on_focus]);

  /*
   * EVENTS
   */

  function measure() {
    if (!ref_running.current) return;

    ref_frame_count.current++;
    ref_request_id.current = requestAnimationFrame(measure);
  }

  /*
   * HTML
   */

  if (!is_authorized) return <></>;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={`FPS: ${fps}`}>
      <div className={`bg-bar flex-1 h-full py-2 overflow-hidden text-xs text-center ${fps < 20 ? 'text-red-600' : 'text-green-600'}`}>{fps}</div>
    </UI_PRIMITIVE__tooltip>
  );
}
